
    // this file was auto generated by python script
    import Link2 from './Link2';
    export default Link2;
    